<!-- <div class="contact-section" id="ContactAdminContainer">
  <button class="btn btn-primary btn-lg" data-toggle="modal" data-target="#contactUsModal"  data-keyboard="false" data-backdrop="static">
    <i class="fa fa-envelope" aria-hidden="true"></i>     
     <span> Contact Euroland Support</span>
  </button>  
</div> -->
<!-- Modal -->
<div class="modal fade" #contactUsModal id="contactUsModal" tabindex="-1" role="dialog" aria-labelledby="contactUsModal"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document" style="min-width: 40%">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="contactUsModalTitle">{{"How-Can-We-Help-You?" | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModalFn()" #closeBtn>
          <!-- <span aria-hidden="true">&times;</span> -->
          <i class="fa fa-times-circle fa-2x whiteColor" aria-hidden="true" tooltip="{{'Close' | translate}}" placement="right"
            container="body"></i>
        </button>
      </div>
      <div class="modal-body">
        <!-- <button type="button" class="btn btn-secondary" style="margin: 5px;"
        (click)="closeBtn.click();">Cancel</button> -->
          <div class="mb-4" *ngIf="this.contactData?.length > 0">
            <div class="chatScroll" id='scrollMe' #scrollMe>
              <div *ngFor="let chat of this.contactData;let i = index;">
                <div class="rightSide d-flex align-items-end flex-column" *ngIf="chat.message">
                  <div translate>
                    Yours-query
                    <!-- {{chat?.name}} -->
                    <!-- <img src="https://img.icons8.com/color/48/000000/circled-user-male-skin-type-7.png" width="30"
                      height="30"> -->
                  </div>
                  <div class="bgColors mr-2 messageBody">{{chat?.message}}</div>
                  <p class="medium text-muted">{{chat?.enquiryOn | date:'MMM d, y hh:mm:ss'}}</p>
                </div>
                <div class="leftSide" *ngIf="chat.reply">
                  <div translate>
                    Admins-reply
                    <!-- <img src="https://img.icons8.com/color/48/000000/circled-user-female-skin-type-7.png" width="30"
                      height="30">
                    {{this.user.firstName}} -->
                  </div>
                  <div class="chat ml-2 messageBody">{{chat?.reply}}</div>
                  <p class="ml-2 medium text-muted">{{chat?.enquiryOn | date:'MMM d, y hh:mm:ss'}}</p>
                </div>
              </div>
            </div>
          </div>
        <div>
          <textarea class="form-control content-request" [(ngModel)]="newMessage" placeholder="{{'Message' | translate}}" rows="4"
            maxlength="1000" #sendTxt></textarea>
      </div>
      </div>
      <div class="contactus-footer">
        <button type="submit" class="btn" appDebounceClick
        (debounceClick)="sendMsg()" translate>Send</button>
      </div>
    </div>
  </div>
</div>


<ng-template #contactTemplate >
  <span class="contactUs" translate >Contact-Us</span>
</ng-template>


<div class="contact-support" data-toggle="modal" data-target="#contactUsModal" data-keyboard="false"
  data-backdrop="static" (click)="this.getContact();this.scrollToBottom();this.autoFocusFn();">
  <div class="contact-support2"></div>
  <div class="contact-support3" triggers="" #pop="bs-tooltip" [tooltip]="contactTemplate" placement="right"></div>
  <div class="contact right"></div>
  </div>

 <button [hidden]="true" type="button" class="btn btn-success" (click)="pop.show()" #tooltips>
  Show
</button>